import { defineNuxtPlugin, onNuxtReady, useNuxtApp, useRuntimeConfig, useRouter } from '#imports'

export default defineNuxtPlugin({
    name: 'apm-plugin',
    parallel: true,
    setup() {
        const config = useRuntimeConfig()
        const router = useRouter()
        const nuxtApp = useNuxtApp()

        onNuxtReady(async () => {
            // Skip under Vitest: onNuxtReady fires after test setup, and the
            // dynamic import below can resolve after the Nuxt test environment
            // is torn down — producing an EnvironmentTeardownError that makes
            // vitest exit non-zero even though every test passes.
            if (import.meta.env.VITEST) return

            // @ts-expect-error No declaration files in package / typescript not supported
            const { ApmVuePlugin } = await import('@elastic/apm-rum-vue')

            nuxtApp.vueApp.use(ApmVuePlugin, {
                router,
                config: config.public.apm || {},
            })
        })
    },
})
